import {Button, Tooltip} from 'platform/components';

import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {SOURCING_USER_LIST_EXPORT_LIMIT} from '../../constants/SOURCING_USER_LIST_EXPORT_LIMIT';

interface SourcingUserListExportButtonProps extends TestIdProps {
  /** The bare action, e.g. "Export all"; the button appends the vehicle count itself. */
  actionLabel: string;
  vehiclesCount: number;
  isExporting: boolean;
  /** Disables the button for a reason of the caller's own, such as the list still loading. */
  isDisabled?: boolean;
  onClick: () => void;
}

/**
 * The export action of a sourcing user list, shared by the page header (whole list) and the
 * bulk action drawer (selection). Disabled above the export limit, with a tooltip saying why,
 * since the backend would refuse the request anyway. Whether an empty list may be exported is
 * the caller's call (`isDisabled`) — the legacy surfaces keep it enabled.
 */
export function SourcingUserListExportButton(props: SourcingUserListExportButtonProps) {
  const isOverLimit = props.vehiclesCount > SOURCING_USER_LIST_EXPORT_LIMIT;

  return (
    <Tooltip
      label={i18n.t('entity.sourcing.labels.exportLimitExceeded', {
        limit: SOURCING_USER_LIST_EXPORT_LIMIT,
      })}
      isDisabled={!isOverLimit}
    >
      <Button
        title={`${props.actionLabel} (${props.vehiclesCount})`}
        variant="outlined"
        leftIcon="content/save_alt"
        isDisabled={props.isDisabled || isOverLimit}
        isLoading={props.isExporting}
        onClick={props.onClick}
        data-testid={props['data-testid']}
      />
    </Tooltip>
  );
}
